





























import { computed, defineComponent, onMounted } from '@vue/composition-api';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import { v4 } from 'uuid';
import FormInput from '@front-app/components/form/FormInput.vue';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import FormError from '@front-app/components/form/FormError.vue';

export default defineComponent({
	components: {
		FormLabel,
		FormSection,
		FormInput,
		FormError,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: true,
		},
		validateOnMounted: Boolean,
	},
	setup(props) {
		const buttonId = `button_${v4()}`;

		// Validation
		const validation = v({
			src: {
				value: computed(() => props.value),
				rules: [required(['https://'])],
			},
		});
		onMounted(() => {
			if (props.validateOnMounted) {
				validation.validate();
			}
		});

		return {
			buttonId,
			validation,
		};
	},
});
